import React from 'react'
import './collection.style.scss'
import  {selectCollection}  from '../../redux/shop-data/shop-data.selector'
import {connect} from 'react-redux'
import ItemPreview from '../../components/item-preview/item-preview.component'

const CollectionPage = ({collection}) => {

  if(!collection) {
    return (
      <div className='collection-page'>
        <h2>Wrong URL</h2>
      </div>
    )
  }
  return (
  <div className='collection-page'>
    <h1 className='title'>{collection.title}</h1>
    <div className='two'>
    {
      collection.items.map(item =>
        <ItemPreview className='item-preview' key={item.id} item={item}/>  
      )
    }
    </div>
  </div>
)
}

const mapStateToProps = (state, ownProps) => ({
  collection: selectCollection(ownProps.match.params.collectionId)(state)
})

export default connect(mapStateToProps)(CollectionPage)


